module.exports = __webpack_public_path__ + "static/iss-dbe1dc521048186d03c2fd4862bab2b9.png";